<template>
  <div style="padding-bottom:20px">
    <mt-header title="预约体验">
      <router-link to="/" slot="left">返回</router-link>
    </mt-header>

    <div class="exp-wrap">
      <div class="seat-title">请先选择预约体验的设备类型(座位)</div>
      <div class="seat-wrap" v-if="mapList.length > 0">
        <div v-for="(item, index) in mapList" :key="index" class="seat-item">
          <div v-show="item.hasChoose" class="check">
            <div class="check-style-unequal-width"></div>
          </div>
          <div
            @click="seatClick(index)"
            :class="{ 'seat-border': item.hasChoose }"
            class="seat-icon"
          >
            <img :src="item.product_image" alt />
          </div>
          <p
            :class="{ 'seat-txt-color': item.hasChoose }"
            class="seat-txt no-wrap"
            style="width:100px"
          >{{ item.product_name }}</p>
        </div>
      </div>
      <div v-else style="font-size:.35rem;padding:12px 15px">
        还没有找到相关体验设备
      </div>

      <div class="dev-title">请选择体验设备</div>
      <div class="dev-wrap">
        <div class="dev-con">
          <div v-show="!hasType" style="font-size:.35rem">请先选择一个设备类型</div>
          <div class="dev-item-wrap" v-show="hasType">
            <div
              @click="chooseDev(index)"
              class="dev-item"
              :class="curIndex === index ? 'avtive' : ''"
              v-for="(item,index) in curDeviceList"
              :key="index"
            >{{item.serial_no}}</div>
          </div>
        </div>
      </div>

      <div class="seat-title">请选择体验时间</div>
      <p class="tips" v-if="curDeviceId === ''">请先选择一个设备</p>
      <div class="time-wrap" v-else>
        <div class="time-nav">
          <div
            class="time-item"
            @click="chooseDay(index)"
            :class="curDay == item.value ? 'avtive-day' : ''"
            v-for="(item,index) in dayList"
            :key="index"
          >{{item.value | formatDay}}</div>
        </div>

        <p class="tips">点击小方块进行预约,一个小方块代表时长15分钟,一个小时划分为4个小方块</p>

        <div class="time-box">
          <div class="time-i" v-for="(item,index) in timeList" :key="index" ref="timeList">
            <p>{{item.startTime | formatTimeTips }}</p>
            <div
              @click="chooseTimeSub(index,ondex)"
              class="time-s"
              :class="[otem.statu == 1 ? 'statu1' : '',otem.statu == -1 ? 'statu-1':'']"
              v-for="(otem,ondex) in item.list"
              :key="ondex"
            >
            <div v-show="ondex != 3" class="time-line" :class="[otem.statu == 1 ? 'statu1' : '',otem.statu == -1 ? 'statu-1':'']"></div>
              <i
                class="iconfont icon-jinzhi"
                v-if="otem.statu == 2"
                style="font-size: 0.45rem;color:rgb(171, 171, 171)"
              ></i>
            </div>
            <p>{{item.endTime | formatEndTimeTips}}</p>
          </div>
        </div>

        <div class="time-show">体验时间：{{curDay}} {{checkTimes | formatTimes}}</div>

        <div class="btn-wrap">
          <div @click="appoint" class="yuyue-btn">马上预约</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCanOrderDevList,
  getDeviceOrderCfg,
  order,
  getDeviceOrderCfgMap,
} from "@/api/api.js";
import { getDateTime, addDate, formatArr, dataFunction } from "@/utils/util";
import chooseTime from "@/components/chooseTime";
import { Toast } from "mint-ui";
import smoothscroll from "smoothscroll-polyfill";
export default {
  data() {
    return {
      mapList: [],
      mapIndex: "",
      hasType: false,

      curDeviceList: [],
      curDeviceId: "",
      curIndex: "",
      curDayIndex: 0,

      dayList: [],
      curDay: getDateTime("today"),

      timeList: [],
      checkTimes: [],
      // defaultFirstDay: true,
    };
  },
  components: {
    chooseTime,
  },
  mounted() {
    this.getCanOrderDevListHandle();
    smoothscroll.polyfill();
  },
  methods: {
    async getDeviceOrderCfgMapHandle() {
      let day = this.curDay.replace(/-/g, "");
      const res = await getDeviceOrderCfgMap({
        device_id: this.curDeviceId,
        day,
      });
      // 整理时间表格
      console.log(res, "resssssssssss");
      let timeObj = res;
      let arr4 = new Array(4).fill("");
      let timeOneList = [];
      let timeTwoList = [];
      for (let key in timeObj) {
        timeOneList.push({
          time: key,
          statu: timeObj[key],
        });
      }

      timeOneList = formatArr(timeOneList);
      let stepLen = timeOneList.length / 4;
      for (let i = 0; i < timeOneList.length; i++) {
        let subArr = [];
        let hasPushAll = false;
        for (let j = 0; j < arr4.length; j++) {
          if (i < stepLen) {
            subArr.push(timeOneList[i * 4 + j]);
          } else {
            hasPushAll = true;
          }
        }
        if (hasPushAll) {
          break;
        }
        timeTwoList.push({
          startTime: timeOneList[i * 4].time,
          endTime: timeOneList[i * 4 + 3].time,
          list: subArr,
        });
      }

      this.timeList = timeTwoList;

      // 定位时间
      this.$nextTick(() => {
        let curHour = dataFunction();
        let curIndex = 0;
        this.timeList.forEach((item, index) => {
          item.list.forEach((otem) => {
            if (otem.time == curHour) {
              curIndex = index;
            }
          });
        });
        let dom = this.$refs.timeList[curIndex]; //真机不+7  测试+7
        dom.scrollIntoView({
          behavior: "smooth",
        });
      });
    },

    async getDeviceOrderCfgHandle() {
      const res = await getDeviceOrderCfg({
        device_id: this.curDeviceId,
      });

      // 获取周期
      console.log(res, "resss");
      let dayInWeek = formatArr(
        JSON.parse(res.time_cfg)[0].dayInWeek.split(",")
      );

      let nextWeek = [];
      dayInWeek.forEach((item) => {
        nextWeek.push(+item + 7);
      });
      dayInWeek = [...dayInWeek, ...nextWeek];
      console.log(dayInWeek, "ressss");
      let curWeek = new Date().getDay();

      let maxPreOrderDay = res.max_pre_order_day; //最大预约天数
      console.log(maxPreOrderDay, "最大预约天数");

      // 定位在周期中开始的位置
      console.log(curWeek, "今天星期几");
      let curIndex = 0;
      let hasToay = false;
      for (let i = 0; i < dayInWeek.length; i++) {
        // 如果周期中有今天
        if (curWeek == dayInWeek[i]) {
          curIndex = i;
          hasToay = true;
          break;
        }
      }

      // 周期中没有今天 找到可以预约的下一天
      if (!hasToay) {
        for (let i = 1; i < 7; i++) {
          let hasCurIndex = false;
          for (let j = 0; j < dayInWeek.length; j++) {
            let tmp = 0;
            if (curWeek + i == 7) {
              tmp = 0;
            } else {
              tmp = curWeek + i;
            }
            if (tmp == dayInWeek[j]) {
              curIndex = j;
              hasCurIndex = true;
              break;
            }
          }
          if (hasCurIndex) {
            break;
          }
        }
      }

      // 算出差度
      let arr = new Array(maxPreOrderDay).fill("");
      let dayList = [];
      for (let i = curIndex; i < curIndex + maxPreOrderDay; i++) {
        dayList.push({
          value: addDate(
            getDateTime("today"),
            parseInt(dayInWeek[i]) - curWeek
          ),
        });
      }

      console.log(curIndex, "定位在周期中开始的位置");
      console.log(dayList, "可用周期");

      this.dayList = dayList;
      this.curDay = this.dayList[this.curDayIndex].value;
      this.getDeviceOrderCfgMapHandle();

      // 整理时间NAV

      // let arr = new Array(maxPreOrderDay + 1).fill("");
      // let dayList = [];
      // arr.length > 0 &&
      //   arr.forEach((item, index) => {
      //     if (index == 0) {
      //       dayList.push({
      //         name: "今天",
      //         value: getDateTime("today"),
      //       });
      //     } else if (index == 1) {
      //       dayList.push({
      //         name: "明天",
      //         value: addDate(getDateTime("today"), index),
      //       });
      //     } else if (index == 2) {
      //       dayList.push({
      //         name: "后天",
      //         value: addDate(getDateTime("today"), index),
      //       });
      //     } else {
      //       let nameArr = addDate(getDateTime("today"), index).split("-");
      //       dayList.push({
      //         name: `${nameArr[1]}-${nameArr[2]}`,
      //         value: addDate(getDateTime("today"), index),
      //       });
      //     }
      //   });
      // this.dayList = dayList;
    },

    async getCanOrderDevListHandle() {
      const res = await getCanOrderDevList();
      let product_image = "";
      let arr = res;
      let map = {},
        dest = [];
      // 归类
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i];
        if (!map[ai.product_id]) {
          if (ai.product_image != "") {
            product_image = ai.product_image;
          }
          dest.push({
            hasChoose: false,
            product_id: ai.product_id,
            product_name: ai.product_name,
            product_image,
            list: [ai],
          });
          map[ai.product_id] = ai;
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j];
            if (dj.product_id == ai.product_id) {
              dj.list.push(ai);
              break;
            }
          }
        }
      }
      this.mapList = dest;
    },

    chooseTimeSub(index, ondex) {
      let curStatu = this.timeList[index].list[ondex].statu;
      if (curStatu == 2) {
        Toast("这个座位暂时不能被预定");
        // this.$messagebox.alert("这个座位暂时不能被预定", "提示");
        return;
      }
      if (curStatu == 1) {
        Toast("这个座位已经被预定");
        // this.$messagebox.alert("这个座位已经被预定", "提示");
        return;
      }
      let curTime = this.timeList[index].list[ondex].time;
      let h = parseInt(+curTime / 100);
      h < 10 ? (h = "0" + h) : h;
      let m = curTime % 100;
      let curTimeFormat = `${getDateTime("today")} ${h}:${m}:00`;

      // 只有今天才会出现过期
      if (this.curDay == getDateTime("today")) {
        if (new Date(curTimeFormat).getTime() < new Date().getTime()) {
          Toast("当前时间已过期");
          return;
        }
      }

      if (curStatu == 0) {
        this.timeList[index].list[ondex].statu = -1;
      }
      if (curStatu == -1) {
        // -1 客户端选中
        this.timeList[index].list[ondex].statu = 0;
      }

      let checkTimes = [];

      this.timeList.forEach((item) => {
        item.list.forEach((otem) => {
          otem.time = +otem.time;
          if (otem.statu == -1) {
            checkTimes.push(otem.time);
          }
        });
      });

      this.checkTimes = checkTimes;
    },

    appoint() {
      if (this.checkBreakPoint()) {
        Toast("选择的预约时间要连续哦");
      } else {
        this.orderHandle();
      }
    },

    async orderHandle() {
      if (this.checkTimes.length == 0) {
        Toast("您还没有选择预约时间哦");
        return false;
      }
      let day = this.curDay.replace(/-/g, "");
      const res = await order({
        device_id: this.curDeviceId,
        day,
        times: JSON.stringify(this.checkTimes),
      });

      Toast("预约成功");
      setTimeout(() => {
        this.$router.replace({
          path: "/experSuc",
          query: {
            logId: res.data.logid,
            pass_key: res.data.pass_key,
          },
        });
      }, 200);
    },

    checkBreakPoint() {
      let breakPoint = false;

      for (let i = 0; i < this.checkTimes.length - 1; i++) {
        let a = this.checkTimes[i] + 15;
        let b = this.checkTimes[i + 1];
        if (a % 100 == 60) {
          let j = parseInt(a / 100) + 1;
          a = j * 100;
        }
        if (a != b) {
          breakPoint = true;
          return breakPoint;
        }
      }
      return breakPoint;
    },

    seatClick(index) {
      if (this.mapList[index].hasChoose) {
        return;
      }
      this.mapList.forEach((item) => {
        item.hasChoose = false;
      });
      this.mapList[index].hasChoose = true;
      this.hasType = true;
      this.mapIndex = index;
      this.curDeviceList = this.mapList[index].list;
      this.curIndex = "";
      this.curDeviceId = "";
    },
    chooseDev(index) {
      this.dayList = [];
      this.curIndex = index;
      this.curDeviceId = this.curDeviceList[index].device_id;
      this.getDeviceOrderCfgHandle();
    },
    chooseDay(index) {
      // this.defaultFirstDay = false;
      this.curDay = this.dayList[index].value;
      this.getDeviceOrderCfgMapHandle();
    },
  },
  filters: {
    formatTimeTips(value) {
      let v = parseInt(value);
      let m = parseInt(value / 100);
      m < 10 ? (m = "0" + m) : m;
      let s = v % 100;
      s < 10 ? (s = "0" + s) : s;
      return `${m}:${s}`;
    },

    formatEndTimeTips(value) {
      let m = parseInt(value / 100) + 1;
      m < 10 ? (m = "0" + m) : m;
      return `${m}:00`;
    },

    formatDay(val) {
      if(getDateTime("today") == val) {
        return `今天`
      }
      return val
    },

    formatTimes(val) {
      if (val.length == 0) {
        return "";
      }
      let sTime = +val[0];
      let sh = parseInt(sTime / 100);
      let sm = parseInt(sTime % 100);

      let eTime = parseInt(val[val.length - 1]) + 15;
      if (eTime % 100 == 60) {
        let j = parseInt(eTime / 100) + 1;
        eTime = j * 100;
      }
      let eh = parseInt(eTime / 100);
      let em = parseInt(eTime % 100);

      sh < 10 ? (sh = "0" + sh) : sh;
      sm < 10 ? (sm = "0" + sm) : sm;
      eh < 10 ? (eh = "0" + eh) : eh;
      em < 10 ? (em = "0" + em) : em;

      return `${sh}:${sm}-${eh}:${em}`;
    },
  },
};
</script>
<style lang="less" scoped>
.seat-title,
.dev-title {
  padding: 12px 15px;
  font-size: 0.4rem;
  font-weight: 700;
}
.avtive {
  background: #26a2ff !important;
}
.avtive-day {
  border-bottom: 4px solid #26a2ff;
}
.page-part {
  margin-bottom: 10px;
}
.is-selected {
  border-bottom: 0.1rem solid #26a2ff !important;
  color: #26a2ff !important;
}
.mint-tab-item-label {
  font-size: 0.3rem !important;
  font-weight: 700 !important;
}
.exp-wrap {
  width: 100%;
  padding: 20px;
  .seat-wrap {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 40px;
    .seat-item {
      // float: left;
      margin-top: 10px;
      margin-right: 20px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .check {
        position: absolute;
        right: 20px;
        top: 10px;
        width: 40px;
        height: 40px;
        background: rgb(10, 147, 235);
        border-radius: 20px;
        .check-style-unequal-width {
          position: absolute;
          top: 40%;
          left: 50%;
          width: 5px;
          height: 14px;
          border-color: #fff;
          border-style: solid;
          border-width: 0 3px 5px 0;
          transform: translateX(-50%) translateY(-50%) rotate(45deg);
        }
      }
      .seat-icon {
        width: 28vw;
        height: 28vw;
        margin-right: 4px;
        box-shadow: 2px 2px 10px #ddd;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        padding: 10px;
        overflow: hidden;
        img {
          height: 60%;
        }
      }
      .seat-txt {
        margin-top: 10px;
        font-size: 0.35rem;
        text-align: center;
      }
    }
  }
  .dev-wrap {
    .dev-con {
      display: flex;
      padding: 20px;
      .dev-item-wrap {
        .dev-item {
          float: left;
          width: 2rem;
          height: 1rem;
          line-height: 1rem;
          text-align: center;
          font-size: 0.35rem;
          background: #ccc;
          color: #fff;
          border-radius: 10px;
          margin-right: 20px;
          margin-bottom: 20px;
        }
      }
    }
  }
}

.time-nav {
  display: flex;
  justify-content: space-around;
  margin-bottom: 10px;
  .time-item {
    flex:1;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

.time-box {
  overflow-y: hidden;
  // overflow-y: scroll;
  display: flex;
  justify-content: space-between;
  .time-i {
    float: left;
    display: flex;
    flex-direction: column;
    align-items: center;
    .time-s {
      width: 60px;
      height: 60px;
      position: relative;
      background: #ccc;
      margin: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      .time-line {
        position: absolute;
        bottom: -30px;
        width: 4px;
        height: 30px;
        background: #ccc;
      }
    }
  }
}

.tips {
  padding: 20px;
}

.time-show {
  margin-top: 20px;
  font-weight: 600;
  font-size: 34px;
  text-align: center;
  color:crimson;
}

.seat-border {
  border: 1px solid#006FEB !important;
}
.seat-txt-color {
  color: #006feb !important;
}

.statu1 {
  background: skyblue !important;
}
.statu-1 {
  background: #006feb !important;
}

.btn-wrap {
  width: 100%;
  .yuyue-btn {
    margin-top: 2vh;
    width: 100%;
    height: 8vh;
    background: #006feb;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.5rem;
    color: #fff;
  }
}
</style>